import useAuthentication from './useAuthentication';


function useIsAuthenticated() {

    const {isAuthenticated} = useAuthentication();

    return isAuthenticated;
}


export default useIsAuthenticated;
